import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function DistrictsIcon({ className }: IconProps) {
  return (
    <svg
      width="75"
      height="118"
      viewBox="0 0 75 118"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2329)">
        <path
          d="M59.1105 37.5133C59.1105 37.5133 76.8011 30.6701 74.8591 19.3594C72.917 8.04873 55.191 12.9418 47.5992 9.92793C40.0074 6.91411 43.2913 -2.83649 34.287 0.780097C25.2828 4.39668 24.9297 14.1827 25.3887 26.5217C25.8478 38.8252 1.51867 58.1136 0.847761 68.3606C0.176857 78.6076 2.26019 83.0397 10.876 80.5932C19.4918 78.1467 0.106236 92.1876 0.000303627 104.597C-0.105629 117.007 27.5427 117.681 27.5427 117.681C27.5427 117.681 33.828 121.439 40.8548 103.392C47.8817 85.3444 41.4198 75.5583 41.7023 67.0842C41.9848 58.61 47.5992 62.1557 49.4 59.851C51.2009 57.5463 49.4 44.4982 59.1458 37.5487L59.1105 37.5133Z"
          fill="#E8ECF7"
        />
        <path
          d="M5.33195 71.4804L2.33054 73.8206C2.08336 73.9979 2.04805 74.317 2.2246 74.5652L6.17941 79.7773C6.35596 80.0255 6.70907 80.061 6.92093 79.8837L9.88703 77.579C10.0989 77.4017 10.1695 77.0826 9.99297 76.8344L6.10878 71.5868C5.93223 71.3386 5.57912 71.3031 5.36726 71.4804"
          fill="#00C4B3"
        />
        <path
          d="M2.89597 110.341C2.64879 110.341 2.40162 110.235 2.18975 110.057C1.80133 109.667 1.80133 109.065 2.18975 108.675L40.5372 70.5586C40.9256 70.1686 41.5259 70.1686 41.9143 70.5586C42.3027 70.9487 42.3027 71.5514 41.9143 71.9414L3.56687 110.057C3.39032 110.235 3.14314 110.341 2.89597 110.341Z"
          fill="#00416B"
        />
        <path
          d="M22.6347 56.7307C22.4228 56.5889 22.2816 56.3407 22.2463 56.0925C22.1757 55.5607 22.5288 55.0643 23.0584 54.9934L50.0711 51.4831C50.6008 51.4122 51.0952 51.7668 51.1658 52.2986C51.2364 52.8305 50.8833 53.3269 50.3536 53.3978L23.3409 56.908C23.0937 56.9435 22.8113 56.8726 22.6347 56.7307Z"
          fill="#00416B"
        />
        <path
          d="M29.6259 117.965C29.3787 117.965 29.1315 117.858 28.9196 117.681L4.94366 93.2867C4.55524 92.8966 4.55524 92.2939 4.94366 91.9038C5.33208 91.5138 5.93236 91.5138 6.32078 91.9038L30.2968 116.298C30.6852 116.688 30.6852 117.291 30.2968 117.681C30.1202 117.858 29.873 117.965 29.6259 117.965Z"
          fill="#00416B"
        />
        <path
          d="M54.9435 41.0942C54.6963 41.0942 54.4139 40.9878 54.2373 40.7751L26.3771 11.3814C26.024 10.9914 26.024 10.3886 26.3771 9.99862C26.7656 9.60859 27.3658 9.64405 27.7543 9.99862L55.6144 39.4277C55.9675 39.8177 55.9675 40.4205 55.5791 40.8105C55.4026 40.9878 55.1554 41.0942 54.9082 41.0942"
          fill="#00416B"
        />
        <path
          d="M21.6809 90.45C21.5044 90.2727 21.3984 90.0245 21.3984 89.7408L22.2459 36.2366C22.2459 35.7048 22.7049 35.2793 23.2346 35.2793C23.7643 35.2793 24.188 35.7402 24.188 36.2721L23.3405 89.7763C23.3405 90.3081 22.8815 90.7336 22.3518 90.7336C22.1047 90.7336 21.8575 90.6273 21.6809 90.45Z"
          fill="#00416B"
        />
        <path
          d="M74.2233 18.0117C74.1173 18.2244 73.9055 18.4017 73.623 18.4726L42.5849 26.9822C42.0552 27.1241 41.5255 26.805 41.3843 26.3086C41.243 25.7767 41.5608 25.2449 42.0552 25.103L73.0933 16.5934C73.623 16.4516 74.1527 16.7707 74.2939 17.2671C74.3645 17.5153 74.2939 17.7635 74.2233 17.9762"
          fill="#00416B"
        />
        <path
          d="M2.86028 64.4956C2.64842 64.3538 2.50718 64.1056 2.47187 63.8574C2.40125 63.3256 2.75435 62.8292 3.28401 62.7583L22.034 60.3117C22.5637 60.2408 23.058 60.5954 23.1286 61.1273C23.1993 61.6591 22.8462 62.1555 22.3165 62.2264L3.5665 64.6729C3.31932 64.7084 3.03684 64.6375 2.86028 64.4956Z"
          fill="#00416B"
        />
        <path
          d="M30.7204 18.0473L26.9069 17.9409C26.6244 17.9409 26.3772 18.1537 26.3419 18.4373L26.0947 24.9614C26.0947 25.245 26.3066 25.4932 26.6244 25.5287L30.3673 25.635C30.6498 25.635 30.897 25.4223 30.9323 25.1386L31.2501 18.6146C31.2501 18.3309 31.0382 18.0473 30.7204 18.0473Z"
          fill="#00C4B3"
        />
        <path
          d="M23.6233 45.9518C23.3761 46.0227 23.1289 45.9872 22.8817 45.8454C22.4227 45.5617 22.2461 44.959 22.5286 44.498L36.1233 21.2739C36.4057 20.8129 36.9707 20.6357 37.4651 20.9193C37.9241 21.203 38.1007 21.7703 37.8182 22.2667L24.2235 45.4908C24.0823 45.7036 23.8704 45.8809 23.6233 45.9518Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2329">
          <rect width="75" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
